import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import useTheme from '../../hooks/useTheme';
import PropTypes from 'prop-types';
import RecentSearchRow from './RecentSearchRow';
import { SideBarCollapseIcon, NavigateFwdIcon } from '../../assets/icons';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSwitchList } from '../../actions/switches/switchApi';
import { encryptData,decryptData } from '../../utils/crypto';

const SwitchSearch = ({
	switchSearch,
	handleFocusIn,
	setSwitchSearch,
	setSearchValue,
	searchValue,
    setMenuOpen,
	setIsFocused,
    switchCount,
    resetPagination,
}) => {
	const { color, FontFace } = useTheme();

	const dispatch = useDispatch();

	const perPage = 4;
	const navigate = useNavigate();
	const [offsetSwitchValue, setOffsetSwitchValue] = useState(0);
	const [currentSwitchPage, setSwitchCurrentPage] = useState(1);
	const maxSwitchPage = Math.ceil(switchCount / perPage);

	const handleSwitchDashboardClick = (item) => {
        const storedData =
            JSON.parse(localStorage.getItem('recentlySearched')) || {};
    
        if (!storedData['Switch']) {
            storedData['Switch'] = [];
        }
    
        const decryptedSerialNumbers = storedData['Switch'].map(encrypted => decryptData(encrypted));
    
        if (!decryptedSerialNumbers.includes(item.serial_no)) {
            const encryptedSerialNo = encryptData(item.serial_no);
            storedData['Switch'].push(encryptedSerialNo);
        }
    
        localStorage.setItem('recentlySearched', JSON.stringify(storedData));
    
        navigate(`switch-detail/${item?.serial_no}`);
        setSearchValue('');
        setMenuOpen(false);
		setIsFocused(false);
    };
    

	const handleSwitchPreviousPage = (event) => {
		// event.stopPropagation();
		handleFocusIn();
		const newOffsetValue = Math.abs(offsetSwitchValue - perPage);
		setOffsetSwitchValue(newOffsetValue);
		setSwitchCurrentPage(Math.max(1, currentSwitchPage - 1));
		if (currentSwitchPage !== 1) {
			switchPageChange(perPage, newOffsetValue);
		}
	};

	const switchPageChange = async (limit, calOffset) => {
		const response = await dispatch(
			getSwitchList(limit, calOffset, null, searchValue)
		);
		if (response?.results?.length > 0) {
			setSwitchSearch(response.results);
		}
	};
	/**
	 * Handler for navigating to the next page.
	 */
	const handleSwitchNextPage = () => {
		handleFocusIn();
		const newOffsetValue = Math.abs(offsetSwitchValue + perPage);
		setOffsetSwitchValue(newOffsetValue);
		setSwitchCurrentPage(Math.min(maxSwitchPage, currentSwitchPage + 1));
		if (currentSwitchPage < maxSwitchPage) {
			switchPageChange(perPage, newOffsetValue);
		}
	};

	// useEffect removed - count is now passed as prop from parent

	// Reset pagination when resetPagination prop changes
	useEffect(() => {
		if (resetPagination) {
			setSwitchCurrentPage(1);
			setOffsetSwitchValue(0);
		}
	}, [resetPagination]);

	return (
		<Grid>
			{switchSearch?.length > 0 && searchValue && (
				<Grid
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						margin: '10px',
					}}
				>
					<Typography
						style={{
							color: color.text.primary,
							fontSize: FontFace.font_size.input_text,
							fontFamily: 'Inter-SemiBold',
						}}
					>
						Switch
					</Typography>
					<Grid
						sx={{
							display: 'flex',
							flexDirection: 'row',
							margin: '3px',
						}}
					>
						<Typography
							variant="h6"
							style={{
								color: color.text.primary,
								fontSize: '12px',
								fontFamily: 'Inter-SemiBold',
								marginTop: '-2.5px',
							}}
						>
							{'('} Showing{' '}
							{Math.min(
								(currentSwitchPage - 1) * perPage + 1,
								switchCount
							)}{' '}
							to{' '}
							{Math.min(
								currentSwitchPage * perPage,
								switchCount
							)}{' '}
							of {switchCount} entries {')'} page :{' '}
							{currentSwitchPage}
						</Typography>
						<div
							onMouseDown={
								currentSwitchPage === 1
									? null
									: handleSwitchPreviousPage
							}
						>
							<SideBarCollapseIcon
								width={'16px'}
								height={'16px'}
							/>
						</div>
						<div
							onMouseDown={
								Math.min(
									currentSwitchPage * perPage,
									switchCount
								) === switchCount
									? null
									: handleSwitchNextPage
							}
						>
							<NavigateFwdIcon width={'16px'} height={'16px'} />
						</div>
					</Grid>
				</Grid>
			)}
			{switchSearch?.length > 0 &&
				searchValue &&
				switchSearch?.map((obj, index) => (
					<RecentSearchRow
						type="search"
						key={index}
						index={index}
						item={obj?.serial_no}
						// handleBookmark={handleBookmark}
						color={color}
						FontFace={FontFace}
						onClick={() => {
							handleSwitchDashboardClick(obj);
						}}
					/>
				))}
		</Grid>
	);
};
SwitchSearch.propTypes = {
	switchSearch: PropTypes.string.isRequired,
	handleFocusIn: PropTypes.func.isRequired,
	setSwitchSearch: PropTypes.func.isRequired,
	searchValue: PropTypes.string.isRequired,
	setSearchValue: PropTypes.func,
    setMenuOpen: PropTypes.func,
	setIsFocused: PropTypes.func,
    switchCount: PropTypes.number,
    resetPagination: PropTypes.bool,
};
export default SwitchSearch;
